import { matchPath } from 'react-router-dom';
import { routes } from '~/constants';
export const isUnknownHomeSubpath = (pathname, knownHomeRouteUrls)=>{
    if (!pathname.startsWith("".concat(routes.home, "/"))) {
        return false;
    }
    return !knownHomeRouteUrls.some((url)=>matchPath(pathname, {
            path: url
        }) != null);
};
